// import React, { useMemo, useState } from "react";
// import { useNavigate } from "react-router-dom";
// import {useSelector} from "react-redux";  
// import {
//   Badge,
//   Box,
//   Button,
//   Divider,
//   IconButton,
//   List,
//   ListItem,
//   ListItemButton,
//   ListItemText,
//   Popover,
//   Stack,
//   Typography,
//   CircularProgress,
//   Tooltip,
// } from "@mui/material";
// import NotificationsIcon from "@mui/icons-material/Notifications";
// import CloseIcon from "@mui/icons-material/Close";
// import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
// import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
// import EventAvailableOutlinedIcon from "@mui/icons-material/EventAvailableOutlined";
// import ErrorOutlineOutlinedIcon from "@mui/icons-material/ErrorOutlineOutlined";
// import { NOTIFICATION_TYPE_CONFIG, NOTIFICATION_TYPES } from "../../constants/notificationTypes";

// const formatNotificationTime = (value) => {
//   if (!value) return "Just now";

//   const date = new Date(value);
//   if (Number.isNaN(date.getTime())) return "Just now";

//   const diffMinutes = Math.max(0, Math.round((Date.now() - date.getTime()) / 60000));
//   if (diffMinutes < 1) return "Just now";
//   if (diffMinutes < 60) return `${diffMinutes} minute${diffMinutes === 1 ? "" : "s"} ago`;

//   const diffHours = Math.round(diffMinutes / 60);
//   if (diffHours < 24) return `${diffHours} hour${diffHours === 1 ? "" : "s"} ago`;

//   const diffDays = Math.round(diffHours / 24);
//   if (diffDays < 7) return `${diffDays} day${diffDays === 1 ? "" : "s"} ago`;

//   return date.toLocaleDateString();
// };

// const getNotificationIcon = (type) => {
//   switch (type) {
//     case NOTIFICATION_TYPES.APPROVAL_REQUEST:
//       return <InfoOutlinedIcon fontSize="small" />;
//     case NOTIFICATION_TYPES.APPROVAL_GRANTED:
//       return <CheckCircleOutlineIcon fontSize="small" />;
//     case NOTIFICATION_TYPES.APPROVAL_REJECTED:
//       return <ErrorOutlineOutlinedIcon fontSize="small" />;
//     case NOTIFICATION_TYPES.EVENT_REMINDER:
//       return <EventAvailableOutlinedIcon fontSize="small" />;
//     case NOTIFICATION_TYPES.SYSTEM_ALERT:
//       return <ErrorOutlineOutlinedIcon fontSize="small" />;
//     default:
//       return <NotificationsIcon fontSize="small" />;
//   }
// };

// const NotificationBell = ({
//   notifications = [],
//   unreadCount = 0,
//   loading = false,
//   error = "",
//   onMarkAllRead,
//   onMarkRead,
//   onRetry,
// }) => {
//   const navigate = useNavigate();
//   const [anchorEl, setAnchorEl] = useState(null);
//   const open = Boolean(anchorEl);

//   const userData = useSelector((state) => state.user.userDetails);
//   console.log("userData in NotificationBell:", userData);
//   const isAdmin = useSelector((s) => ["HeadOffice", "SuperAdmin", "Admin"].includes(s?.user?.userDetails?.userRole));
// console.log("isAdmin in NotificationBell:", isAdmin); 

//   const handleOpen = (event) => setAnchorEl(event.currentTarget);
//   const handleClose = () => setAnchorEl(null);

//   const listItems = useMemo(
//     () => (notifications || []).filter((item) => item?.isRead !== true),
//     [notifications]
//   );

//   // const handleNotificationClick = (item) => {
//   //   if (item?.actionUrl && typeof item.actionUrl === "string" && item.actionUrl.trim()) {
//   //     handleClose();
//   //     if (item.isRead !== true && onMarkRead) {
//   //       onMarkRead(item._id || item.id);
//   //     }
//   //     navigate(item.actionUrl);
//   //     return;
//   //   }

//   //   if (item?.isRead !== true && onMarkRead) {
//   //     onMarkRead(item._id || item.id);
//   //   }
//   //   handleClose();
//   // };

//   const handleMarkRead = (event, item) => {
//     event.stopPropagation();
//     if (item?.isRead !== true && onMarkRead) {
//       onMarkRead(item._id || item.id);
//     }
//   };



//   return (
//     <>
//       <IconButton
//         color="inherit"
//         onClick={handleOpen}
//         aria-label="notifications"
//         sx={{ color: "#fff", position: "relative" }}
//       >
//         <Badge badgeContent={unreadCount > 0 ? unreadCount : null} color="error">
//           <NotificationsIcon sx={{ color: "#fff" }} />
//         </Badge>
//       </IconButton>

//       <Popover
//         open={open}
//         anchorEl={anchorEl}
//         onClose={handleClose}
//         anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
//         transformOrigin={{ vertical: "top", horizontal: "right" }}
//         PaperProps={{
//           sx: {
//             maxWidth: 360,
//             maxHeight: 600,
//             borderRadius: 2,
//             overflow: "hidden",
//             boxShadow: "0px 8px 24px rgba(0,0,0,0.15)",
//           },
//         }}
//       >
//         <Box sx={{ p: 1.5, borderBottom: "1px solid #eef2f6" }}>
//           <Stack direction="row" justifyContent="space-between" alignItems="center">
//             <Typography variant="subtitle1" sx={{ fontWeight: 700, color: "#183B56" }}>
//               Notifications
//             </Typography>
//             {listItems.length > 0 && (
//               <Button
//                 variant="text"
//                 size="small"
//                 onClick={onMarkAllRead}
//                 sx={{ textTransform: "none", minWidth: "auto", p: 0, color: "#0F6CBD" }}
//               >
//                 Mark all as read
//               </Button>
//             )}
//           </Stack>
//         </Box>

//         {loading ? (
//           <Box sx={{ display: "flex", justifyContent: "center", py: 4 }}>
//             <CircularProgress size={20} />
//           </Box>
//         ) : error ? (
//           <Box sx={{ p: 2 }}>
//             <Typography variant="body2" color="error.main" sx={{ mb: 1 }}>
//               {error}
//             </Typography>
//             {onRetry && (
//               <Button variant="outlined" size="small" onClick={onRetry}>
//                 Retry
//               </Button>
//             )}
//           </Box>
//         ) : listItems.length === 0 ? (
//           <Box sx={{ p: 3, textAlign: "center" }}>
//             <Typography variant="body2" color="text.secondary">
//               No notifications
//             </Typography>

// {isAdmin &&

//  <Box sx={{ p: 1.5, borderTop: "1px solid #eef2f6", textAlign: "center" }}>
//               <Button
//                 variant="text"
//                 size="small"
//                 onClick={() => {
//                   handleClose();
//                   navigate("/notifications");
//                 }}
//                 sx={{ textTransform: "none", color: "#4687a5" }}
//               >
//                 View all notifications
//               </Button>
//             </Box>


// } 


//           </Box>
//         ) : (
//           <>
//             <List sx={{ p: 1, maxHeight: 430, overflowY: "auto" }}>
//               {listItems.map((item) => {
//               const itemId = item._id || item.id;
//               const config = NOTIFICATION_TYPE_CONFIG[item?.type] || NOTIFICATION_TYPE_CONFIG[NOTIFICATION_TYPES.GENERAL];
//               const isUnread = item?.isRead === false || item?.isRead === undefined;

//               return (
//                 <React.Fragment key={itemId || `${item.title}-${item.createdAt}` }>
//                   <ListItem
//                     disablePadding
//                     sx={{ mb: 1 }}
//                     secondaryAction={
//                       <Tooltip title="Mark it as read">
//                         <IconButton
//                           edge="end"
//                           size="small"
//                           aria-label="Mark it as read"
//                           onClick={(event) => handleMarkRead(event, item)}
//                           sx={{ mr: 0.5, color: "#6b7280" }}
//                         >
//                           <CloseIcon fontSize="small" />
//                         </IconButton>
//                       </Tooltip>
//                     }
//                   >
//                     <ListItemButton
//                       // onClick={() => handleNotificationClick(item)}
//                       sx={{
//                         borderRadius: 2,
//                         border: isUnread ? `1px solid ${config.accent}33` : "1px solid rgba(0,0,0,0.06)",
//                         background: isUnread ? "rgba(15,108,189,0.04)" : "#fff",
//                         alignItems: "flex-start",
//                         p: 1.25,
//                         pr: 5,
//                       }}
//                     >
//                       <Box sx={{ mr: 1.5, mt: 0.5, color: config.accent }}>
//                         {getNotificationIcon(item?.type)}
//                       </Box>

//                       <ListItemText
//                         primary={
//                           <Box sx={{ display: "flex", alignItems: "center", gap: 1, flexWrap: "wrap" }}>
//                             <Typography variant="body2" sx={{ fontWeight: 700, color: "#183B56" }}>
//                               {item?.title || config.label}
//                             </Typography>
//                             {isUnread && (
//                               <Box
//                                 sx={{
//                                   width: 8,
//                                   height: 8,
//                                   borderRadius: "50%",
//                                   backgroundColor: config.accent,
//                                 }}
//                               />
//                             )}
//                           </Box>
//                         }
//                         secondary={
//                           <>
//                             <Typography variant="body2" sx={{ color: "#4b5563", mt: 0.4 }}>
//                               {item?.message || item?.details || "No details available."}
//                             </Typography>
//                             <Typography variant="caption" sx={{ color: "#6b7280", mt: 0.5, display: "block" }}>
//                               {formatNotificationTime(item?.createdAt)}
//                             </Typography>
//                           </>
//                         }
//                       />
//                     </ListItemButton>
//                   </ListItem>
//                   <Divider sx={{ my: 0.5 }} />
//                 </React.Fragment>
//               );
//               })}               
//             </List>
// {isAdmin &&


//  <Box sx={{ p: 1.5, borderTop: "1px solid #eef2f6", textAlign: "center" }}>
//               <Button
//                 variant="text"
//                 size="small"
//                 onClick={() => {
//                   handleClose();
//                   navigate("/notifications");
//                 }}
//                 sx={{ textTransform: "none", color: "#4687a5" }}
//               >
//                 View all notifications
//               </Button>
//             </Box>

// }

         
//           </>
//         )}
        
//       </Popover>
//     </>
//   );
// };

// export default NotificationBell;
















import React, {
  useMemo,
  useState,
} from "react";

import {
  Badge,
  Box,
  Button,
  Divider,
  IconButton,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
  Popover,
  Stack,
  Typography,
  CircularProgress,
  Tooltip,
} from "@mui/material";

import NotificationsIcon from
  "@mui/icons-material/Notifications";

import CloseIcon from
  "@mui/icons-material/Close";

import CheckCircleOutlineIcon from
  "@mui/icons-material/CheckCircleOutline";

import InfoOutlinedIcon from
  "@mui/icons-material/InfoOutlined";

import EventAvailableOutlinedIcon from
  "@mui/icons-material/EventAvailableOutlined";

import ErrorOutlineOutlinedIcon from
  "@mui/icons-material/ErrorOutlineOutlined";

import { useNavigate } from
  "react-router-dom";

import {
  NOTIFICATION_TYPE_CONFIG,
  NOTIFICATION_TYPES,
} from "../../constants/notificationTypes";

const formatNotificationTime =
  (value) => {

    if (!value) {
      return "Just now";
    }

    const date =
      new Date(value);

    if (
      Number.isNaN(
        date.getTime()
      )
    ) {
      return "Just now";
    }

    const diffMinutes =
      Math.max(
        0,
        Math.round(
          (Date.now() -
            date.getTime()) /
            60000
        )
      );

    if (diffMinutes < 1) {
      return "Just now";
    }

    if (diffMinutes < 60) {
      return `${diffMinutes} minute${
        diffMinutes === 1
          ? ""
          : "s"
      } ago`;
    }

    const diffHours =
      Math.round(
        diffMinutes / 60
      );

    if (diffHours < 24) {
      return `${diffHours} hour${
        diffHours === 1
          ? ""
          : "s"
      } ago`;
    }

    const diffDays =
      Math.round(
        diffHours / 24
      );

    if (diffDays < 7) {
      return `${diffDays} day${
        diffDays === 1
          ? ""
          : "s"
      } ago`;
    }

    return date.toLocaleDateString();
  };

const getNotificationIcon =
  (type) => {

    switch (type) {

      case NOTIFICATION_TYPES.APPROVAL_REQUEST:
        return (
          <InfoOutlinedIcon
            fontSize="small"
          />
        );

      case NOTIFICATION_TYPES.APPROVAL_GRANTED:
        return (
          <CheckCircleOutlineIcon
            fontSize="small"
          />
        );

      case NOTIFICATION_TYPES.APPROVAL_REJECTED:
        return (
          <ErrorOutlineOutlinedIcon
            fontSize="small"
          />
        );

      case NOTIFICATION_TYPES.EVENT_REMINDER:
        return (
          <EventAvailableOutlinedIcon
            fontSize="small"
          />
        );

      case NOTIFICATION_TYPES.SYSTEM_ALERT:
        return (
          <ErrorOutlineOutlinedIcon
            fontSize="small"
          />
        );

      default:
        return (
          <NotificationsIcon
            fontSize="small"
          />
        );
    }
  };

const NotificationBell = ({
  notifications = [],
  unreadCount = 0,
  loading = false,
  error = "",
  onMarkAllRead,
  onMarkRead,
  onRetry,
}) => {

  const navigate =
    useNavigate();

  const [
    anchorEl,
    setAnchorEl,
  ] = useState(null);

  const open =
    Boolean(anchorEl);

  const handleOpen =
    (event) => {
      setAnchorEl(
        event.currentTarget
      );
    };

  const handleClose =
    () => {
      setAnchorEl(null);
    };

  // Only unread notifications
  const unreadNotifications =
    useMemo(
      () =>
        (notifications || [])
          .filter(
            (item) =>
              item?.isRead !== true
          ),
      [notifications]
    );

  const handleMarkRead =
    async (
      event,
      item
    ) => {

      event.stopPropagation();

      const id =
        item?._id ||
        item?.id;

      if (
        id &&
        onMarkRead
      ) {
        await onMarkRead(id);
      }
    };

  const handleNotificationClick =
    async (item) => {

      const id =
        item?._id ||
        item?.id;

      if (
        item?.isRead !== true &&
        onMarkRead &&
        id
      ) {
        await onMarkRead(id);
      }

      handleClose();

      if (
        item?.actionUrl
      ) {
        navigate(
          item.actionUrl
        );
      }
    };

  return (
    <>
      {/* =====================================================
          NOTIFICATION BELL
      ===================================================== */}

      <Tooltip title="Notifications">

        <IconButton
          color="inherit"
          onClick={handleOpen}
          aria-label="notifications"
          sx={{
            color: "#fff",
            position: "relative",
          }}
        >

          <Badge
            badgeContent={
              unreadCount > 0
                ? unreadCount
                : null
            }
            color="error"
          >

            <NotificationsIcon
              sx={{
                color: "#fff",
              }}
            />

          </Badge>

        </IconButton>

      </Tooltip>

      {/* =====================================================
          POPOVER
      ===================================================== */}

      <Popover
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        PaperProps={{
          sx: {
            width: 380,
            maxHeight: 600,
            borderRadius: 2,
            overflow: "hidden",
            boxShadow:
              "0px 8px 24px rgba(0,0,0,0.15)",
          },
        }}
      >

        {/* HEADER */}

        <Box
          sx={{
            p: 1.5,
            borderBottom:
              "1px solid #eef2f6",
          }}
        >

          <Stack
            direction="row"
            justifyContent="space-between"
            alignItems="center"
          >

            <Typography
              variant="subtitle1"
              sx={{
                fontWeight: 700,
                color: "#183B56",
              }}
            >
              Notifications
            </Typography>

            <Stack
              direction="row"
              alignItems="center"
              spacing={1}
            >

              {unreadNotifications
                .length > 0 && (
                <Button
                  variant="text"
                  size="small"
                  onClick={
                    onMarkAllRead
                  }
                  sx={{
                    textTransform:
                      "none",
                    minWidth:
                      "auto",
                    p: 0,
                  }}
                >
                  Mark all as read
                </Button>
              )}

              <IconButton
                onClick={
                  handleClose
                }
                size="small"
              >
                <CloseIcon
                  fontSize="small"
                />
              </IconButton>

            </Stack>

          </Stack>

        </Box>

        {/* LOADING */}

        {loading ? (

          <Box
            sx={{
              display: "flex",
              justifyContent:
                "center",
              py: 4,
            }}
          >
            <CircularProgress
              size={24}
            />
          </Box>

        ) : error ? (

          <Box sx={{ p: 2 }}>

            <Typography
              color="error"
              variant="body2"
              sx={{ mb: 1 }}
            >
              {error}
            </Typography>

            {onRetry && (
              <Button
                variant="outlined"
                size="small"
                onClick={onRetry}
              >
                Retry
              </Button>
            )}

          </Box>

        ) : unreadNotifications
            .length === 0 ? (

          <Box
            sx={{
              p: 4,
              textAlign: "center",
            }}
          >

            <NotificationsIcon
              sx={{
                fontSize: 40,
                color: "#c5cdd5",
                mb: 1,
              }}
            />

            <Typography
              variant="body2"
              color="text.secondary"
            >
              No new notifications
            </Typography>

          </Box>

        ) : (

          <List
            sx={{
              p: 1,
              maxHeight: 450,
              overflowY: "auto",
            }}
          >

            {unreadNotifications.map(
              (item) => {

                const itemId =
                  item._id ||
                  item.id;

                const config =
                  NOTIFICATION_TYPE_CONFIG[
                    item?.type
                  ] ||
                  NOTIFICATION_TYPE_CONFIG[
                    NOTIFICATION_TYPES
                      .GENERAL
                  ];

                return (
                  <React.Fragment
                    key={itemId}
                  >

                    <ListItem
                      disablePadding
                      sx={{
                        mb: 1,
                      }}
                      secondaryAction={

                        <Tooltip
                          title="Mark as read"
                        >

                          <IconButton
                            edge="end"
                            size="small"
                            onClick={(
                              event
                            ) =>
                              handleMarkRead(
                                event,
                                item
                              )
                            }
                          >

                            <CloseIcon
                              fontSize="small"
                            />

                          </IconButton>

                        </Tooltip>
                      }
                    >

                      <ListItemButton
                        onClick={() =>
                          handleNotificationClick(
                            item
                          )
                        }
                        sx={{
                          borderRadius: 2,

                          border:
                            `1px solid ${
                              config?.accent ||
                              "#0F6CBD"
                            }33`,

                          background:
                            "rgba(15,108,189,0.04)",

                          alignItems:
                            "flex-start",

                          p: 1.25,

                          pr: 5,
                        }}
                      >

                        <Box
                          sx={{
                            mr: 1.5,
                            mt: 0.5,
                            color:
                              config?.accent ||
                              "#0F6CBD",
                          }}
                        >

                          {getNotificationIcon(
                            item?.type
                          )}

                        </Box>

                        <ListItemText

                          primary={
                            <Typography
                              variant="body2"
                              sx={{
                                fontWeight: 700,
                                color:
                                  "#183B56",
                              }}
                            >
                              {item?.title ||
                                config?.label ||
                                "Notification"}
                            </Typography>
                          }

                          secondary={
                            <>
                              <Typography
                                variant="body2"
                                sx={{
                                  color:
                                    "#4b5563",
                                  mt: 0.4,
                                }}
                              >
                                {item?.message ||
                                  "No details available."}
                              </Typography>

                              <Typography
                                variant="caption"
                                sx={{
                                  color:
                                    "#6b7280",
                                  mt: 0.5,
                                  display:
                                    "block",
                                }}
                              >
                                {formatNotificationTime(
                                  item?.createdAt
                                )}
                              </Typography>
                            </>
                          }
                        />

                      </ListItemButton>

                    </ListItem>

                    <Divider
                      sx={{
                        my: 0.5,
                      }}
                    />

                  </React.Fragment>
                );
              }
            )}

          </List>
        )}

        {/* VIEW ALL */}

        <Box
          sx={{
            p: 1.5,
            borderTop:
              "1px solid #eef2f6",
            textAlign: "center",
          }}
        >

          <Button
            variant="text"
            size="small"
            onClick={() => {
              handleClose();
              navigate(
                "/notifications"
              );
            }}
            sx={{
              textTransform:
                "none",
            }}
          >
            View all notifications
          </Button>

        </Box>

      </Popover>
    </>
  );
};

export default NotificationBell;